// extracted by mini-css-extract-plugin
export default {"expandable-container":"g__expandable-container--RVYLF","overflow-layout":"g__overflow-layout--rH5zC","collapse-footer":"g__collapse-footer--WTNW9"};